module.exports = __webpack_public_path__ + "static/media/displacement-liquid.c5e2e62d.png";